import React, { useEffect, useState } from "react";
import { user_type, token } from "../../config";
import { useNavigate } from "react-router-dom";
import SimpleAreaChart from "../../component/chart/area/SimpleAreaChart";
import ArcProgressChart from "../../component/chart/arcprogress/ArcProgressChart";
import BarChart1 from "../../component/chart/bar/BarChart1";
import SimplePieChart from "../../component/chart/pie/SimplePieChart";
import DonutChartWithLabel from "../../component/chart/donut/DonutChartWithLabel";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import Spinner from "../../component/loadingbar/Spinner";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";
import Swal from "sweetalert2";

const Home = () => {
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState([]);

  const [cardData, setCardData] = useState({
    totalStudent: "",
    totalCourses: "",
    totalTPT: "",
    totalTeacher: "",
  });

  const getCardData = () => {
    setLoading(true);
    fetch(`${config.host_url}pages/admin-dashboard`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setCardData({
            totalStudent: data.data.students,
            totalCourses: data.data.courses,
            totalTPT: data.data.tpt,
            totalTeacher: data.data.teachers,
          });
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (user_type === "Sales Admin") {
      navigate("/saleshome");
    }
    getCardData();
  }, [token]);
  const chartData = React.useMemo(
    () => [
      {
        label: "Series 1",
        data: [
          ["Total", 8],
          ["Passed", 7],
          ["Failed", 1],
          ["", 0],
        ],
      },
    ],
    []
  );
  const chartData2 = React.useMemo(
    () => [
      {
        label: "Total",
        data: [
          ["Course 1", 8],
          ["Course 2", 7],
          ["Course 3", 4],
          ["", 0],
        ],
      },
      {
        label: "Passed",
        data: [
          ["Course 1", 5],
          ["Course 2", 2],
          ["Course 3", 1],
          ["", 0],
        ],
      },
      {
        label: "Fail",
        data: [
          ["Course 1", 3],
          ["Course 2", 5],
          ["Course 3", 3],
          ["", 0],
        ],
      },
    ],
    []
  );

  const fetchOrder = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.host_url}/pages/orders`, {
        method: "GET",
        headers: {
          token: token,
        },
      });

      if (!response.ok) {
        // Log response details for debugging
        console.error("Error response:", response);
        if (response.status === 401) {
          triggerNotification("error", "Unauthenticated user");
        } else {
          triggerNotification(
            "error",
            "Internal server error, Please try after some time!!"
          );
        }
        return;
      }

      const data = await response.json();
      console.log("Response data:", data);
      //  ------For TableViewer ------
      const OrderData = data.map((d) => ({
        enroll_datetime: new Date(d.enroll_datetime).toLocaleString(),
        full_name: `${d.first_name} ${d.last_name}`,
        // icon: pkg.pkg_display_icon,
        transactionid: d.transactionid,
        scid: d.scid
        // location: pkg.location,
        // datetime: new Date(pkg.datetime).toLocaleString(),
        // idNumber: pkg.userid,
      }));
      setRowData(OrderData);
      //  ------For TableViewer ------


      if (data.status === 200) {
        console.log("Success data:", data);
      } else if (data.status === 401) {
        triggerNotification("error", "Unauthenticated user");
      } else {
        triggerNotification(
          "error",
          // "Internal server error, Please try after some time!!"
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
      triggerNotification("error", "Error fetching login tracks.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, [token]);

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },

    { headerName: "Order Date", field: "enroll_datetime", filter: true },
    { headerName: "Full Name", field: "full_name", filter: true },
    // { headerName: "Last Name", field: "last_name", filter: true },
    { headerName: "Transactionid", field: "transactionid", filter: true },
    // { headerName: "SCID", field: "scid", filter: true },
    {
      headerName: "Actions",
      field: "actions",
      width: 300,
      cellRenderer: ({ data }) => (
        <div className="flex justify-start">
          {/* View Button */}
          <button
            className="btn btn-icon btn-primary m-2 mb-1"
            onClick={() => showHandle(data.transactionid)}
          >
            <span className="tf-icons mdi mdi-eye"></span>
          </button>
    
          {/* Edit Button */}
          <button
            className="btn btn-sm btn-warning m-2 mb-1"
             onClick={() => handleOrders(data.transactionid,1)}
          >
            Approve
          </button>
    
          {/* Delete Button */}
          <button
            className="btn btn-sm btn-danger m-2 mb-1"
             onClick={() => deleteHandle(data.transactionid)}
          >
           Reject
          </button>
        </div>
      ),
    }
    
  ];

  const deleteHandle = (transactionid) =>{
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleOrders(transactionid,0);
      }
    });
    }

   const handleOrders = async(transactionid,status) =>{
    try {
      const response = await fetch(`${config.host_url}/pages/order/${transactionid}/${status}`, { 
        method: "GET", // Use "POST" if your API expects it
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }else{
        fetchOrder();
      }
  
      // const data = await response.json();
      // console.log("API Response:", data);
  
      // Handle success response
      console.log("Transaction delete successfully!");
     
    } catch (error) {
      // console.error("Error while approving transaction:", error);
      console.log("Failed to approve the transaction.");
    }
   } 

  // TableViewer columns definitions for modal content
  const modalColDefs = [
    { headerName: "#", width: 50, valueFormatter: (params) => `${params.node.id + 1}` },
    { headerName: "Course Name", field: "course_name" },
    // { headerName: "Course Type", field: "course_type" },
    { headerName: "Plan Price", field: "plan_price" },
    // { headerName: "Plan Unit", field: "plan_unit" },

    // {
    //   headerName: "Actions",
    //   field: "actions",
    //   cellRenderer: ({ data }) => (
    //     <button onClick={() => alert(`Viewing: ${data.course_name}`)}>View</button>
    //   ),
    // },
  ];

  const modalRowData = modalContent.length > 0
    ? modalContent.map((item) => ({
      course_id: item.course_id,
      course_name: item.course_name,
      course_type: item.course_type,
      plan_price: `${item.plan_price}/${item.plan_unit[0].toUpperCase()}`,
      plan_unit: item.plan_unit,
      promotional_price: item.promotional_price,
      image_link: item.image_link,
      actions: "", // Placeholder for actions column
    }))
    : [];

  const showHandle = async (transactionId) => {
    console.log("Viewing details for transaction ID:", transactionId);
    setIsModalOpen(true);

    try {
      // Perform API call
      const response = await fetch(`${config.host_url}/pages/orders/${transactionId}`, {
        method: "GET",
        headers: {
          token: token, // Replace with your actual token
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        // Handle HTTP errors
        console.error("Failed to fetch transaction details. Status:", response.status);
        if (response.status === 401) {
          triggerNotification("error", "Unauthenticated user");
        } else {
          triggerNotification(
            "error",
            "Failed to fetch transaction details. Please try again!"
          );
        }
        return;
      }

      // Parse response JSON
      const data = await response.json();
      console.log("Fetched Transaction Details:", data);
      setModalContent(data);



      // Handle transaction data (e.g., update state or display details)
      if (data.status === 200) {
        console.log("Transaction Data:", data.data);
        // Example: Update state with fetched data
        // setTransactionDetails(data.data);
      } else {
        console.error("API returned an error:", data.message);
        // triggerNotification("error", data.message || "Error fetching transaction details.");
      }
    } catch (error) {
      console.error("Error while fetching transaction details:", error);
      triggerNotification("error", "An unexpected error occurred.");
    }
  };
  console.log("model content", modalContent);

  const openModal = () => {
    // setModalContent(rowData);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);

  };

  return (
    <>
      <Breadcrumb txt="Home" subpath={["Dashboard"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex ">
            <h5 className="mb-0">Dashboard</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="row flex  justify-around">
              {/* <h3 className="display-6">
          Welcome back,{" "}
          <span className="fw-semibold">
            {localStorage.usertype === "teacher"
              ? "Teacher"
              : localStorage.usertype === "admin"
              ? "Admin"
              : ""}
          </span>{" "}
          👋🏻{" "}
        </h3> */}
              <div className="flex justify-between px-4 py-2 row">
                <div className="col-sm-3 ">
                  <div className="card" style={{ height: "125px" }}>
                    <div className="card-body">
                      <h5> {cardData.totalStudent} </h5>
                      <p className="mb-lg-2 mb-xl-3">Total Student</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3 ">
                  <div className="card" style={{ height: "125px" }}>
                    <div className="card-body">
                      <h5> {cardData.totalCourses} </h5>
                      <p className="mb-lg-2 mb-xl-3">Total Courses</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3  ">
                  <div className="card" style={{ height: "125px" }}>
                    <div className="card-body">
                      <h5>{cardData.totalTeacher} </h5>
                      <p className="mb-lg-2 mb-xl-3">Total Teacher</p>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3  ">
                  <div className="card" style={{ height: "125px" }}>
                    <div className="card-body">
                      <h5>{cardData.totalTPT} </h5>
                      <p className="mb-lg-2 mb-xl-3">
                        Total Third Party Teacher
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pt-2">
                {/* <div className="col-md-5">
                  <SimpleAreaChart />
                </div> */}
                {/* <div className="col-md-5">
                  <BarChart1 data={chartData2} />
                </div> */}
                {/* <div className="col-md-5">
                  <ArcProgressChart />
                </div> */}
                {/* <div className="col-md-5 mt-5">
                  <BarChart1 data={chartData} />
                </div> */}
                {/* <div className="col-md-5 mt-5">
                  <SimplePieChart />
                </div> */}
              </div>
              {/* <DonutChartWithLabel /> */}
            </div>

          )}
          {loading ? (
            <Spinner />
          ) : (
            <>
              <div className="px-3 pb-3  table-responsive">
                <TableViewer
                  rowData={rowData}
                  colDefs={colDefs}
                //onEdit={btnEditHandle}
                // onDelete={btnDeleteHandle}
                // onView={showHandle}
                // onRowClicked={rowClickHandler}
                // onRowClicked={() => openModal(rowData)} 
                // haveImage
                />
              </div>
              {isModalOpen && modalContent.length > 0 && (
                <div className="popup-overlay">
                  <div className="popup-content relative">
                    <h2 className="text-xl font-semibold mb-4">Course Details</h2>

                    {/* Table Viewer */}
                    <div className="px-3 pb-3 table-responsive h-85">
                      <TableViewer rowData={modalRowData} colDefs={modalColDefs} />
                    </div>

                    {/* Close icon */}
                    <button
                      className="absolute top-2 right-2 text-2xl text-gray-500 hover:text-gray-700"
                      onClick={closeModal}
                    >
                      &times; {/* Close icon */}
                    </button>
                  </div>
                </div>
              )}

            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Home;
